<template lang="pug">
  .popularGiftSearchSlide.grey-background(ref="giftSearch")
    .max-width-grid
      h4.black What is the most popular way to search for gifts?<span class="super"><a href="https://solutions.ups.com/UPS-pulse-of-the-online-shopper-2019-LP.html?WT.mc_id=PRESSRELEASE_PRESSROOM_POTOS_STUDY_07301" target="_blank">8</a></span>
      .chart-wrapper
        PopularGiftSearch
        .text-block.one
          p.p2 Search Engine
        .text-block.two
          p.p2 Amazon
        .text-block.three
          p.p2 Retailer Website
        .text-block.four
          p.p2 Price<br>Comparison<br>Website
        .text-block.five
          p.p2 Consumer<br>Review Website
        .text-block.six
          p.p2 Social Media
</template>

<script>
import PopularGiftSearch from '@/assets/img/barCharts/popularGiftSearch.svg'

export default {
  name: 'popularGiftSearchSlide',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const getBars = this.$el.querySelectorAll('rect')
    const heights = [...getBars].map(el => el.getAttribute('height'))
    const yVal = [...getBars].map(el => el.getAttribute('y'))

    this.timeline = new TimelineLite({ paused: true })
   
    getBars.forEach((bar, i) => {
      let height = parseFloat(heights[i])
      let y = parseFloat(yVal[i])
      let animateFrom = height + y
      this.timeline
        .fromTo(bar, 1, {attr: { y: animateFrom, height: 0 } }, {attr:{ y: yVal[i], height: heights[i] } }, '-=0.75')
    })

    // this.timeline = new TimelineLite({ paused: true })

    // getBars.forEach((bar, i) => {
    //   this.timeline.fromTo(bar, 1, { height: 0, y: heights[i] }, { height: heights[i], y: 0 }, '-=0.75')
    // })
  },
  computed: {
  },
  methods: {
    playAnimation () {
      this.timeline.seek(0)
      this.timeline.play()
    },
  },
  components: {
    PopularGiftSearch,
  },
}
</script>

<style scoped lang="scss">
.popularGiftSearchSlide {
  height: 58rem;
  padding-top: 5rem;
  text-align: center;

  h4 {
    padding-bottom: 4.4rem;
  }
  
  .chart-wrapper {
    max-width: 71%;
    margin: 0 auto;
    position: relative;
  }

  .p2 {
    line-height: 1.5rem;
  }

  .text-block {
    top: 110%;
    &.one { left: 6%; }
    &.two { left: 23.5%; }
    &.three { left: 36.5%; }
    &.four { left: 53.5%; }
    &.five { left: 68%; }
    &.six { left: 84%; }
  }

  @media #{$mobile} {
    .chart-wrapper {
      max-width: 78%;
    }

    .p2 {
      line-height: 2rem;
    }
  }
}
</style>
